import Button from "@material-ui/core/Button"
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ApiException, RelayApiClient } from '../generated/ApiClient'
import * as AlertSnackbarStore from '../store/AlertSnackbarStore'
import { v4 as uuidv4 } from 'uuid';

export enum ButtonAction {
    PowerCycle = 'PowerCycle'
}


export type DebouncedButtonProps = {
    /** disable time delay in milliseconds  */
    delay?: number
    /** Button click function set explicitly on the component */
    onButtonClick?: () => void
    buttonAction?: ButtonAction
    modemId?: string
    disabled?: boolean
}

export function DebounceButton(props: DebouncedButtonProps) {

    const [isDisabled, setDisabled] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!isDisabled) {
            // timeout elapsed, nothing to do
            return;
        }
        // isDisabled was changed to true, set back to false after `delay`
        const handle = setTimeout(() => {
            setDisabled(false);
        }, props.delay);
        return () => clearTimeout(handle);
    }, [isDisabled, props.delay]);

    const handleClick = () => {
        if (isDisabled) {
            return;
        }
        if (props.buttonAction == ButtonAction.PowerCycle)
            powerCycle();

        if (props.onButtonClick)
            props.onButtonClick();

        setDisabled(true);
    }

    const powerCycle = async () => {
        try {
            const data = await new RelayApiClient().postForwardRequest(props.modemId, uuidv4(), "powercycle")
            dispatch(AlertSnackbarStore.actionCreators.addMessage({ title: "Power Cycle sent", message: `Power Cycle command was sent to modem`, alertType: 'success' }))
        }
        catch (error) {
            dispatch(AlertSnackbarStore.actionCreators.addError(error, undefined, 'Error sending Power Cycle command to modem'))
        }
    }

    return (
        <Button variant='contained' color='primary' disabled={isDisabled || props.disabled} onClick={() => handleClick()} onMouseEnter={e => e.currentTarget.classList.replace('btn-dark', 'btn-success')}
            onMouseOut={e => e.currentTarget.classList.replace('btn-success', 'btn-dark')}
        > Reboot</Button >
    )

}